import {RemoteGetProvidersMedicalGuideV3} from 'data/usecases/private/guide-flow/medical-guide/remote-get-providers-v3';
import {GetProvidersMedicalGuideV3} from 'domain/usecases/private/guide-flow/medical-guide/get-providers-v3';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProvidersMedicalGuideV3 = (): GetProvidersMedicalGuideV3 =>
	new RemoteGetProvidersMedicalGuideV3(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideProvidersV3),
		makeAuthorizeHttpClientDecorator(),
	);
